import React from 'react';
import { motion } from 'framer-motion';
import '../styles/landingPage.css';

function LandingPage() {
  return (
    <header className='landing-page-container'>
      <div className="landing-hero-text">
        {/* Animated Heading */}
        <motion.h1
          initial={{ opacity: 0, y: -50 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1, ease: 'easeOut' }}
        >
          <span>The Lead: </span>Excellence in Service, Trust in Relationships
        </motion.h1>

        {/* Animated Paragraph */}
        <motion.p
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1, delay: 0.5, ease: 'easeOut' }}
        >
          We provide safe, dependable and efficient services delivered with best 
          international practices while building a sustainable relationship with our stakeholders.
        </motion.p>

        {/* Animated Button */}
        <motion.a 
          className='landing-page-btn' 
          href='/Quote'
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 1, ease: 'easeOut' }}
          whileHover={{ scale: 1.1 }}
        >
          Request a Quote
        </motion.a>
      </div>
    </header>
  );
}

export default LandingPage;
